var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlovakiaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H0V14.9997H22.5V0Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 4.89136H0V10.1084H22.5V4.89136Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.1084H0V14.9997H22.5V10.1084Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68945 4.23901V7.98034C5.68945 10.1086 8.46974 10.7606 8.46974 10.7606C8.46974 10.7606 11.2499 10.1085 11.2499 7.98034V4.23901H5.68945Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42151 4.34875V7.94968C6.42151 8.19015 6.4749 8.41726 6.58072 8.63017C7.63058 8.63017 9.19982 8.63017 10.3587 8.63017C10.4645 8.4173 10.5179 8.19019 10.5179 7.94968V4.34875H6.42151Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72513 6.85938H8.7836V6.2317H9.41131V5.60403H8.7836V4.97632H8.15593V5.60403H7.5283V6.2317H8.15593V6.85938H7.21436V7.48709H8.15593V8.11476H8.7836V7.48709H9.72513V6.85938Z",
    fill: "#F0F0F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43699 9.50632C7.84146 9.76046 8.25701 9.90812 8.46979 9.97373C8.68257 9.90807 9.09812 9.7605 9.50259 9.50632C9.91049 9.24999 10.1965 8.95674 10.3588 8.6301C10.1797 8.5034 9.96125 8.4287 9.72522 8.4287C9.63926 8.4287 9.55577 8.43889 9.47552 8.45757C9.30541 8.07103 8.91926 7.80103 8.46988 7.80103C8.02045 7.80103 7.63435 8.07103 7.46423 8.45757C7.38395 8.43889 7.30041 8.4287 7.21454 8.4287C6.97846 8.4287 6.75997 8.50345 6.58093 8.6301C6.74313 8.95674 7.02909 9.24999 7.43699 9.50632Z",
    fill: "#0052B4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakiaFlag);
export default __webpack_public_path__ + "static/media/slovakia-flag.0bc073f0784006cede4c4832416b80a6.svg";
export { ForwardRef as ReactComponent };